/* eslint import/prefer-default-export: 0 */
export const SET_LISTING_LOADING = 'SET_LISTING_LOADING';
export const SET_LISTING_ERROR = 'SET_LISTING_ERROR';
